import { Container } from 'unstated'

export class AppContainer extends Container {
  state = {
    selectedImage: '',
    linesArray: [],
    startDrawIdx: [],
    imageMask: '',
    processedImageMask: '',
    requestComplete: false,
    resultImage: '',
    requestId: '',
    termsAccepted: false
  }

  setSelectedImage = (selectedImage) => this.setState({ selectedImage })
  setLinesArray = (linesArray) => this.setState({ linesArray })
  setStartDrawIdx = (startDrawIdx) => this.setState({ startDrawIdx })
  setImageMask = (imageMask) => this.setState({ imageMask })
  setProcessedImageMask = (processedImageMask) => this.setState({ processedImageMask })
  setRequestComplete = (requestComplete) => this.setState({ requestComplete })
  setResultImage = (resultImage) => this.setState({ resultImage })
  setRequestId = (requestId) => this.setState({ requestId })
}



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js